// ---------------------------------------------------------------
// date.js — Utilidades de fecha (semana empieza en lunes, es-ES)
// ---------------------------------------------------------------
export const MONTHS = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

export const WEEKDAYS_SHORT = ["L", "M", "X", "J", "V", "S", "D"];
export const WEEKDAYS = ["lun", "mar", "mié", "jue", "vie", "sáb", "dom"];

const pad = (n) => String(n).padStart(2, "0");

/** Date -> "YYYY-MM-DD" (zona horaria local) */
export function toISO(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/** "YYYY-MM-DD" -> Date (mediodía local para evitar saltos de zona horaria) */
export function fromISO(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d, 12);
}

export function isToday(date) {
  return toISO(date) === toISO(new Date());
}

/** ¿Ya ha pasado ese día? (hoy NO cuenta como pasado)
 *  Se compara en texto ISO a propósito: así no hay que preocuparse de
 *  horas, husos ni del cambio de hora. */
export function esPasado(date) {
  return toISO(date) < toISO(new Date());
}

/** Índice de columna con semana empezando en lunes (lun=0 … dom=6) */
export function mondayIndex(date) {
  return (date.getDay() + 6) % 7;
}

/**
 * Matriz del mes: array de semanas, cada semana con 7 objetos
 * { date, inMonth } — incluye días de relleno del mes anterior/siguiente.
 */
export function monthMatrix(year, month) {
  const first = new Date(year, month, 1);
  const start = new Date(first);
  start.setDate(first.getDate() - mondayIndex(first));

  const weeks = [];
  const cursor = new Date(start);
  do {
    const week = [];
    for (let i = 0; i < 7; i++) {
      week.push({ date: new Date(cursor), inMonth: cursor.getMonth() === month });
      cursor.setDate(cursor.getDate() + 1);
    }
    weeks.push(week);
  } while (cursor.getMonth() === month);
  return weeks;
}

/** "HH:MM" -> minutos desde medianoche */
export function timeToMinutes(time) {
  if (!time) return 0;
  const [h, m] = time.split(":").map(Number);
  return h * 60 + (m || 0);
}

/** Título largo: "lunes, 14 de julio de 2026" */
export function longDate(date) {
  return date.toLocaleDateString("es-ES", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
